/*
 * LockUnlockWallet actions
 */
import * as reqHandler from '../../config/services/serviceHandler';
import endpoint from '../../config/endPoints';
import {
  clearDefaultError,
  rootApiResponse,
} from '../HeaderContainer/actions';
import {
  errorResponse, successResponse,
} from '../../devUtils/commonUtils';
import { utils } from '../../devUtils';
import { DEFAULT_ACTION, LOCK_UNLOCK_WALLET_SUCCESS } from './constants';
import { FETCH_CARD_DATA_YSC } from '../NetworkCards/constants';

const lockUnlockWalletSuccess = (payload) => ({ type: LOCK_UNLOCK_WALLET_SUCCESS, payload });
const fetchCardDataYscSuccess = (payload) => ({ type: FETCH_CARD_DATA_YSC, payload });

const lockUnlockWallet = (payload) => async (dispatch, getState, api) => {
  try {
    dispatch(utils.isReducerLoading(DEFAULT_ACTION, true));
    dispatch(clearDefaultError());
    const authPrerequist = utils.getAuthPrerequist(getState, true);
    let res = {};
    res = await reqHandler.postHandler(api, endpoint.POST_NARADA_LOCK_UNLOCK_WALLET, payload, authPrerequist);
    res.status = true;
    if (res && res.status) {
      dispatch(lockUnlockWalletSuccess(res));
      dispatch(rootApiResponse(successResponse(DEFAULT_ACTION, res.message)));
      return dispatch(utils.isReducerLoading(DEFAULT_ACTION));
    }
    throw (res.message);
  } catch (err) {
    dispatch(lockUnlockWalletSuccess({ status: false }));
    dispatch(rootApiResponse(errorResponse(DEFAULT_ACTION, err)));
    return dispatch(utils.isReducerLoading(DEFAULT_ACTION));
  }
};

const fetchCardDataYsc = (payload) => async (dispatch, getState, api) => {
  try {
    dispatch(utils.isReducerLoading(DEFAULT_ACTION, true));
    dispatch(clearDefaultError());
    const authPrerequist = utils.getAuthPrerequist(getState, true);
    const res = await reqHandler.postHandler(api, endpoint.GET_YSC_CARD_DETAIL, payload, authPrerequist);
    res.status = true;
    if (res && res.status) {
      return dispatch(fetchCardDataYscSuccess(res));
    }
    throw (res.message);
  } catch (err) {
    dispatch(fetchCardDataYscSuccess({ status: false }));
    return dispatch(rootApiResponse(errorResponse(DEFAULT_ACTION, err)));
  }
};


export { lockUnlockWallet, fetchCardDataYsc };



// WEBPACK FOOTER //
// client/containers/YscWalletLockUnlock/actions.js